import es from './es';
import esCr from './esCr';
import pt from './pt';

const locale = {
  pt,
  es,
  'es-CR': esCr,
  // Uruguai não tem textos próprios: usa o bundle do Paraguai.
  'es-UY': es,
};

export default locale;
